import { makeStyles } from "@mui/styles";

export const infoSection = makeStyles(() => ({
    deleteIcon: {
        color: "rgb(222, 53, 11)",
    },
    buttonsContainer: {
        paddingTop: 20,
    },
    expansionPanel: {
        display: "block",
        width: "100%",
    },
    expansionPanelDetails: {
        paddingTop: 15,
    },
    expansionPanelSummay: {},
    addButtonContainer: {
        textAlign: "right",
        
    },
    listItemContainer: {},
    scroll: {},
    contactListContainer: {
        marginBottom: 1,
        display: "flex",
        
        overflowY: "hidden",
        overflowX: "hidden",
        flexDirection: "column",
    },

    pronounRoot: {
        width: "100%",
        "& > div" : {
            marginTop: 7
        },
        "& > div > div" : {
            flexWrap: "nowrap"
        }
    }
}));
